<!-- <div class="bg-card flex min-w-0 flex-auto flex-col dark:bg-transparent sm:absolute sm:inset-0 sm:overflow-hidden"> -->
<!-- Main Content (Table and Paginator) -->
<div class="flex flex-auto flex-col overflow-auto">
  <!-- Tabla -->
  <div class="container mt-0 flex-auto flex-col">
    <div class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900">
      <table
        class="w-full table-fixed mat-elevation-z"
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortDisableClear
        multiTemplateDataRows
      >
        <ng-container matColumnDef="det">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button
              class="h-7 min-h-7 min-w-10 px-2 leading-6"
              (click)="toggleDetails(element)"
              style="margin-left: 10px"
            >
              <mat-icon
                class="icon-size-5"
                [svgIcon]="
                    selectedOrder?._id === element._id
                      ? 'heroicons_solid:chevron-up'
                      : 'heroicons_solid:chevron-down'
                  "
              ></mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="check">
            <th mat-header-cell *matHeaderCellDef class="text-left first-col">
              <mat-checkbox
                color="primary"
                (change)="
                  $event ? masterToggle() : null; onCheckboxChange($event)
                "
                [checked]="selection.hasValue() && isAllSelected()"
                [aria-label]="checkboxLabel()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element" class="text-left first-col">
              <mat-checkbox
                color="primary"
                (click)="
                  $event.stopPropagation(); onCheckboxChange($event, element)
                "
                (change)="$event ? selection.toggle(element) : null"
                [checked]="selection.isSelected(element)"
                [aria-label]="checkboxLabel(element)"
                [disabled]="!validateDataToSynchronize(element)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="px-6 text-left first-col table-tittle w-min-detail"
          ></th>
          <td
            mat-cell
            *matCellDef="let element"
            class="px-6 text-center first-col table-text"
          >
            <mat-icon
              *ngIf="element.paymentReview == 6"
              svgIcon="heroicons_solid:play-circle"
              matTooltip="En progreso"
              style="color: rgb(236, 199, 58); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.paymentReview == 7"
              svgIcon="heroicons_solid:check-circle"
              matTooltip="Aceptado"
              style="color: rgb(9, 133, 50); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.paymentReview == 8"
              svgIcon="heroicons_solid:x-circle"
              matTooltip="Rechazado"
              style="color: rgb(255, 0, 0); cursor: pointer"
            ></mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="statusERP">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="px-6 text-left first-col table-tittle w-min-detail"
          ></th>
          <td
            mat-cell
            *matCellDef="let element"
            class="px-6 text-center first-col table-text"
          >
            <mat-icon
              *ngIf="element.paymentStatus == 0"
              svgIcon="heroicons_solid:clock"
              matTooltip="Pendiente envío a ERP"
              style="color: rgb(233, 124, 61); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.paymentStatus == 1"
              svgIcon="heroicons_solid:document-arrow-up"
              matTooltip="Enviado a ERP"
              style="color: rgb(65, 106, 218); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.paymentStatus == 3"
              svgIcon="heroicons_solid:document-check"
              matTooltip="Creado en ERP"
              style="color: rgb(9, 133, 50); cursor: pointer"
            ></mat-icon>
            <mat-icon
              *ngIf="element.paymentStatus == 4"
              svgIcon="heroicons_solid:exclamation-triangle"
              matTooltip="Error en ERP"
              style="color: rgb(255, 0, 0); cursor: pointer"
            ></mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          ></th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <span
              *ngIf="element?.subApplication?.code == 'CSMOBILE-BACKOFFICE'"
              style="
                background-color: rgb(40, 101, 141);
                color: white;
                padding: 3px 6px 3px 5px;
                border-radius: 5px;
                margin-left: 7px;
                margin-right: 7px;
                cursor: pointer;
              "
              [matTooltip]="element?.subApplication?.name"
            >
              B
            </span>
            <span
              *ngIf="element?.subApplication?.code == 'CSMOBILE-APP'"
              style="
                background-color: rgb(218, 41, 28);
                color: white;
                padding: 3px 6px 3px 5px;
                border-radius: 5px;
                margin-left: 7px;
                margin-right: 7px;
                cursor: pointer;
              "
              [matTooltip]="element?.subApplication?.name"
            >
              A
            </span>
            <span
              *ngIf="element?.subApplication?.code == 'CSMOBILE-ERP'"
              style="
                background-color: rgb(255, 123, 0);
                color: white;
                padding: 3px 6px 3px 5px;
                border-radius: 5px;
                margin-left: 7px;
                margin-right: 7px;
                cursor: pointer;
              "
              [matTooltip]="'ERP'"
            >
              E
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="businessPartner">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            Pagador/Receptor
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <app-business-partner-display
              [soldTo]="element.soldTo"
              [shipTo]="element.shipTo"
              [customerType]="element.shipToType"
              [showIcons]="true">
            </app-business-partner-display>
          </td>
        </ng-container>
        <ng-container matColumnDef="documentNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            <span style="text-align: left">Nro. Doc.</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <p class="table-text-m" style="min-width: 55px">
              <span class="table-text-code">{{ element?.serials }}</span><br />
              {{ element?.document }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="class">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            Clase
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <p class="table-text-m">
              @if (element.document_class) {
              <span
                class="table-text-code"
                *ngIf="getCode(element.document_class) as code"
              >
                {{ code }} <br />
              </span>
              } {{ element?.document_class?.name }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="payment_method">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            Método de Pago
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <p class="table-text-m">
              @if (element.paymentMethod) {
              <span
                class="table-text-code"
                *ngIf="getCode(element.paymentMethod) as code"
              >
                {{ code }} <br />
              </span>
              } {{ element?.paymentMethod?.name }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="payment_type">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            <p class="px-6">Tipo de Pago</p>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <p class="table-text-m">
              @if (element.paymentType) {
              <span
                class="table-text-code"
                *ngIf="getCode(element.paymentType) as code"
              >
                {{ code }} <br />
              </span>
              } {{ element?.paymentType?.name }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="text-left first-col table-tittle"
          >
            Fecha
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="text-left first-col table-text"
          >
            <p class="table-text-m" style="min-width: 130px">
              {{ formatDate(element.dateHour) }}
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="subTotal">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="first-col table-tittle text-right"
          >
            <span class="table-text-m-2">Abono</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.paying | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="surcharge">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left first-col table-tittle"
          >
            <span class="table-text-m-2">Recargo</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.totalSurcharges | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="discount">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="tfirst-col table-tittle text-right"
          >
            <span class="table-text-m-2">Descuento</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.totalDiscounts | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="tax">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="first-col table-tittle text-right"
          >
            <span class="table-text-m-2">Impuesto</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.totalTaxes | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <ng-container matColumnDef="total">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="first-col table-tittle text-right"
          >
            <span class="table-text-m-2">Total</span>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="first-col table-text text-right"
          >
            <p class="table-text-m-2">
              {{ element?.amount | decimalFormat }}
            </p>
          </td>
        </ng-container>
        <!-- <ng-container matColumnDef="creation">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="text-left first-col table-tittle"
            >
              Creación
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="text-left first-col table-text"
            >
              {{ formatDate(element?.creationDateTime, false) }}<br />{{
                formatHour(element?.creationDateTime)
              }}
            </td>
          </ng-container> -->
        <ng-container matColumnDef="actions">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="text-left first-col"
            style="min-width: 40px"
          >
            <button
              mat-icon-button
              color="primary"
              [matMenuTriggerFor]="filterMenu"
              matTooltip="Sincronizar"
            >
              <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col">
            <button
              mat-icon-button
              [matMenuTriggerFor]="actionMenu"
              matTooltip="Acciones"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu">
              <!--<button *ngIf="element?.statusId != StatusEnum.INACTIVE && element?.statusId != StatusEnum.ORDER_APPROVED && element?.statusId != StatusEnum.ORDER_REJECTED" 
                                  mat-menu-item (click)="onUpdateOrder(element)"
                                  [disabled]="!(
                                      validateDataToEdit(element)
                                    )">
                                  <mat-icon
                                    svgIcon="heroicons_outline:pencil-square"
                                  ></mat-icon>
                                  <span>Editar</span>
                                </button>-->
              <button mat-menu-item>
                <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                <span>Sincronizar</span>
              </button>
              <!--<button mat-menu-item (click)="generateOrder(element)"
                                  [disabled]="!(
                                    validateDataToGenerateOrder(element)
                                  )">
                                  <mat-icon svgIcon="heroicons_outline:arrow-right-circle"></mat-icon>
                                  <span>Generar Cotización</span>
                                </button>
                                <button mat-menu-item (click)="cloneOrder(element, 'copy')"
                                  [disabled]="!(
                                      validateDataToCopy(element)
                                    )">
                                  <mat-icon svgIcon="heroicons_outline:document-duplicate"></mat-icon>
                                  <span>Copiar</span>
                                </button>
                                <button mat-menu-item (click)="cloneOrder(element, 'divide')"
                                  [disabled]="!(
                                      validateDataToDivide(element)
                                    )">
                                  <mat-icon svgIcon="heroicons_outline:clipboard-document"></mat-icon>
                                  <span>Dividir</span>
                                </button>-->
              <!-- <button mat-menu-item>
                <mat-icon>visibility</mat-icon>
                <span>Visualizar logs</span>
              </button> -->
              <!--<button mat-menu-item (click)="openModal(element)" [disabled]="!(validateDataToAppOrRejected(element))">
                                  <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                                  <span>{{projectName == 'DIUNSA' ? 'Rechazar' : 'Aprobar/Rechazar'}}</span>
                                </button>-->
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="displayedColumns.length"
          >
            <ng-container *ngIf="selectedOrder?._id === element._id">
              <ng-container
                *ngTemplateOutlet="
                      nestedTableTemplate;
                      context: { $implicit: row }
                    "
              ></ng-container>
            </ng-container></td
        ></ng-container>

        <!-- Header Row -->
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"
          class="sticky top-0 z-10  bg-white dark:bg-gray-900"
        ></tr>
        <!-- Fila principal -->
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="border-b"
          [class.table-expanded-row]="selectedOrder?._id === element._id"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="table-detail-row"
        ></tr>
      </table>
    </div>
    <div
      *ngIf="this.dataSource.data.length === 0"
      class="border-t p-8 text-center text-1xl sm:p-10"
    >
      Lo sentimos, no hay registros para mostrar.
    </div>
  </div>

  <!-- Paginación -->
  <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
    <mat-paginator
      class="z-10"
      [pageSizeOptions]="[50, 100, 150, 200]"
      showFirstLastButtons
      [length]="totalItems"
      [pageSize]="pageSize"
      (page)="changePage($event)"
    ></mat-paginator>
  </div>
</div>
<!-- Modales -->
<!-- </div>   -->
<ng-template #rowDetailsTemplate let-order>
  <div class="overflow-hidden">
    <div class="flex border-b">
      <form class="flex w-full flex-col">
        <div class="flex flex-col py-3 px-12 sm:flex-row">
          <div class="flex flex-auto flex-wrap">
            <div class="grid-container table-text">
              <div class="row">
                <div class="cell cell-3 table-title">Pagador:</div>
                <div class="cell cell-4">
                  {{ selectedOrder.soldTo?.externalKeys?.code + " - " }} {{
                  selectedOrder.soldTo?.name }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Destinatario:</div>
                <div class="cell cell-4">
                  {{ selectedOrder.shipTo?.externalKeys?.code + " - " }} {{
                  selectedOrder.shipTo?.name }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Dirección:</div>
                <div class="cell cell-4">
                  {{ selectedOrder.address?.address }} {{
                  selectedOrder.address?.postalCode ? " / " +
                  selectedOrder.address?.postalCode : " " }} {{
                  selectedOrder.address?.contactName ? " / " +
                  selectedOrder.address?.contactName : " " }} {{
                  selectedOrder.address?.locationTwo?.name ? " / " +
                  selectedOrder.address?.locationTwo?.name : " " }} {{
                  selectedOrder.address?.LocationThree?.name ? " / " +
                  selectedOrder.address?.LocationThree?.name : " " }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Clase de Expedición:</div>
                <div class="cell cell-4">
                  {{ selectedOrder?.expeditionCondition?.externalKeys?.code }} -
                  {{ selectedOrder?.expeditionCondition?.name }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Condición de Pago:</div>
                <div class="cell cell-4">
                  {{ selectedOrder?.paymentCondition?.externalKeys?.code }} - {{
                  selectedOrder?.paymentCondition?.name }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Observaciones:</div>
                <div class="cell cell-4">
                  {{ selectedOrder?.note ?? " - " }}
                </div>
              </div>
              <div class="row"></div>
            </div>
            <div class="grid-container table-text">
              <div class="row">
                <div class="cell cell-3 table-title">Estado Global:</div>
                <div class="cell cell-4">
                  {{ getExtraStatusName(selectedOrder?.extraStatusERP, "GLOBAL")
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de rechazo:</div>
                <div class="cell cell-4">
                  {{ getExtraStatusName(selectedOrder?.extraStatusERP, "REJECT")
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de entrega:</div>
                <div class="cell cell-4">
                  {{ getExtraStatusName( selectedOrder?.extraStatusERP,
                  "DELIVERY" ) }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de crédito:</div>
                <div class="cell cell-4">
                  {{ getExtraStatusName(selectedOrder?.extraStatusERP, "CREDIT")
                  }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de factura:</div>
                <div class="cell cell-4">
                  {{ getExtraStatusName(selectedOrder?.extraStatusERP,
                  "INVOICE") }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Estado de usuario:</div>
                <div class="cell cell-4">
                  {{ getExtraStatusName(selectedOrder?.extraStatusERP, "USER")
                  }}
                </div>
              </div>
            </div>
            <div class="grid-container table-text">
              <div class="row">
                <div class="cell cell-3 table-title">SubTotal:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.subTotal | decimalFormat }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Recargo:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.totalSurcharges | decimalFormat }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Descuento:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.totalDiscounts | decimalFormat }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Impuesto:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.totalTaxes | decimalFormat }}
                </div>
              </div>
              <div class="row">
                <div class="cell cell-3 table-title">Total:</div>
                <div class="cell cell-4 text-right">
                  {{ selectedOrder?.total | decimalFormat }}
                </div>
              </div>
            </div>
            <div class="flex w-full flex-col">
              <table
                class="min-w-500 overflow-y-visible mat-elevation-z mt-3"
                mat-table
                [dataSource]="dataSourceDetail"
                matSort
              >
                <ng-container matColumnDef="material">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="px-6 text-left first-col table-tittle"
                  >
                    <span style="margin-left: 5px">Material</span>
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 text-left first-col table-text"
                  >
                    <p class="table-text-m">
                      <span
                        class="table-text-code"
                        *ngIf="getCode(detail.material) as code"
                        [style.textDecoration]="
                            detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                          "
                        [style.textDecorationColor]="
                            detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                          "
                      >
                        {{ code }}
                      </span>
                      <span *ngIf="detail.statusId == StatusEnum.INACTIVE" style="color: red"
                        ><b> (Eliminado)</b></span
                      ><br />
                      <span
                        [style.textDecoration]="
                            detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                          "
                        [style.textDecorationColor]="
                            detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                          "
                      >
                        {{ detail.material?.name }}
                      </span>
                    </p>
                  </td>
                </ng-container>
                <ng-container matColumnDef="note">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="px-6 text-left first-col table-tittle"
                  >
                    Nota
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 text-left first-col table-text"
                  >
                    <button
                      mat-icon-button
                      color="primary"
                      matTooltip="{{ detail.note }}"
                      [disabled]="!(detail.note && detail.note != '')"
                    >
                      <mat-icon
                        svgIcon="heroicons_outline:chat-bubble-bottom-center-text"
                      ></mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="warehouse">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="px-6 text-left first-col table-tittle"
                  >
                    Almacén
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 text-left first-col table-text"
                  >
                    <p *ngIf="!detail.isEditMode" class="table-text-m">
                      <span
                        class="table-text-code"
                        *ngIf="getCode(detail.warehouse) as code"
                      >
                        {{ code }} <br />
                      </span>
                      {{ detail.warehouse?.name }}
                    </p>
                    <mat-form-field
                      *ngIf="detail.isEditMode"
                      class="mt-2 w-full"
                      appearance="fill"
                      floatLabel="never"
                    >
                      <mat-select
                        [(ngModel)]="detail.warehouse"
                        placeholder="Almacén"
                        matTooltip="{{ detail.warehouse?.name }}"
                        [ngModelOptions]="{ standalone: true }"
                        [compareWith]="compareById"
                        (selectionChange)="
                            detail.thereIsChanges = true;
                            onChangeWarehouseInOrderDetail(detail)
                          "
                      >
                        @for ( warehouse of selectedOrder.warehousesToUpdate ||
                        []; track warehouse ) {
                        <mat-option [value]="warehouse" class="text-content">
                          {{ warehouse.externalKeys?.code + " - " }}{{
                          warehouse.name }}
                        </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="soldQuantity">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="text-left first-col table-tittle"
                  >
                    <span class="table-text-m-2 pd-l">Cantidad</span>
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="text-left first-col table-text"
                  >
                    <p class="table-text-m-2 pd-l">
                      <app-unit-measure-display
                        [usedUnit]="{
                          quantity: detail?.soldQuantity,
                          unitId: detail?.soldUnitOfMeasure?._id,
                          unitName: detail?.soldUnitOfMeasure?.name,
                          unitAbbreviation: detail?.soldUnitOfMeasure?.code
                        }"
                        [baseUnit]="{
                          quantity: detail?.baseQuantity,
                          unitId: detail?.baseUnitOfMeasure?._id,
                          unitName: detail?.baseUnitOfMeasure?.name,
                          unitAbbreviation: detail?.baseUnitOfMeasure?.code
                        }"
                        [parallelUnit]="{
                          quantity: detail?.pararellQuantity,
                          unitId: detail?.pararellUnitOfMeasure?._id,
                          unitName: detail?.pararellUnitOfMeasure?.name,
                          unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                        }"
                        [material]="{
                          _id: detail?.material?._id,
                          code: detail?.material?.code,
                          UMPActive: detail?.material?.UMPActive
                        }"
                        [companyUMPActive]="UMPActive"
                        [statusId]="detail.statusId"
                      ></app-unit-measure-display>
                    </p>
                  </td>

                  <!-- <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-center">Cantidad</th>
                                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-center">
                                      <span *ngIf="!detail.isEditMode"
                                        [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'" 
                                        [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE  ? 'red' : 'inherit'">
                                        {{ detail?.soldQuantity}} ({{detail?.soldUnitOfMeasure?.name}})
                                      </span>
                                      <mat-form-field *ngIf="detail.isEditMode" class="mt-2" appearance="fill" floatLabel="never"
                                        style="margin-bottom: -1.2em;">
                                        <input matInput type="number" [(ngModel)]="detail.soldQuantity" placeholder="Cantidad" 
                                          [ngModelOptions]="{standalone: true}" aria-label="Cantidad" matInput 
                                          (change)="onChangeQuantityInOrderDetail(selectedOrder, detail)" 
                                          (keyup)="onChangeQuantityInOrderDetail(selectedOrder, detail)">
                                        <span matSuffix>{{detail.soldUnitOfMeasure?.code}}</span>
                                      </mat-form-field>
                                      <br><span *ngIf="detail.stockToValidate !== undefined"
                                        style="font-size: 0.9em;">
                                        <b [style.color]="detail.stockToValidate >= detail.soldQuantity ? 'green' : 'inherit'">
                                          Disponible: 
                                        </b> {{detail.stockToValidate}}
                                      </span>
                                    </td> -->
                </ng-container>
                <ng-container matColumnDef="unitPrice">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="px-6 first-col table-tittle text-center"
                  >
                    Precio
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 first-col table-text text-center"
                  >
                    @if ( detail.isEditMode &&
                    selectedOrder.class.canUpdatePrices == true ) {
                    <mat-form-field
                      class="mt-2"
                      appearance="fill"
                      floatLabel="never"
                    >
                      <input
                        matInput
                        type="number"
                        [(ngModel)]="detail.unitPrice"
                        placeholder="Precio"
                        [ngModelOptions]="{ standalone: true }"
                        aria-label="Precio"
                        matInput
                        (change)="
                              onChangePriceInOrderDetail(selectedOrder, detail)
                            "
                        (keyup)="
                              onChangePriceInOrderDetail(selectedOrder, detail)
                            "
                      />
                    </mat-form-field>
                    } @else {
                    <span
                      [style.textDecoration]="
                            detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                          "
                      [style.textDecorationColor]="
                            detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                          "
                    >
                      {{ detail?.unitPrice | decimalFormat }}
                    </span>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="subTotal">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    arrowPosition="before"
                    class="px-6 text-left first-col table-tittle"
                  >
                    SubTotal
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 text-left first-col table-text text-right"
                  >
                    <span
                      [style.textDecoration]="
                          detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                        "
                      [style.textDecorationColor]="
                          detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                        "
                    >
                      {{ detail?.subTotal | decimalFormat }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="totalSurcharges">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    arrowPosition="before"
                    class="px-6 text-left first-col table-tittle"
                  >
                    Recargo
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 text-left first-col table-text text-right"
                  >
                    <span
                      [style.textDecoration]="
                          detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                        "
                      [style.textDecorationColor]="
                          detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                        "
                    >
                      {{ detail?.totalSurcharges | decimalFormat }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="totalDiscounts">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    arrowPosition="before"
                    class="px-6 text-left first-col table-tittle"
                  >
                    Descuento
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 text-left first-col table-text text-right"
                  >
                    <span
                      [style.textDecoration]="
                          detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                        "
                      [style.textDecorationColor]="
                          detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                        "
                    >
                      {{ detail?.totalDiscounts | decimalFormat }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="tax">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    arrowPosition="before"
                    class="px-6 text-left first-col table-tittle"
                  >
                    Impuesto
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 text-left first-col table-text text-right"
                  >
                    <span
                      [style.textDecoration]="
                          detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                        "
                      [style.textDecorationColor]="
                          detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                        "
                    >
                      {{ detail?.totalTaxes | decimalFormat }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="total">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    arrowPosition="before"
                    class="px-6 text-left first-col table-tittle"
                  >
                    Total
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 text-left first-col table-text text-right"
                  >
                    <span
                      [style.textDecoration]="
                          detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'
                        "
                      [style.textDecorationColor]="
                          detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'
                        "
                    >
                      {{ detail?.total | decimalFormat }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="px-6 first-col table-tittle text-center"
                  >
                    <button
                      *ngIf="validateDataToEdit(selectedOrder)"
                      mat-icon-button
                      color="primary"
                      (click)="onAddOrderDetail(selectedOrder)"
                      matTooltip="Agregar detalle"
                    >
                      <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    </button>
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let detail"
                    class="px-6 first-col table-text text-center"
                  >
                    <div
                      *ngIf="
                          detail.statusId != StatusEnum.INACTIVE &&
                          validateDataToEdit(selectedOrder)
                        "
                    >
                      <button
                        *ngIf="!detail.isEditMode"
                        color="primary"
                        mat-icon-button
                        (click)="detail.isEditMode = true"
                        matTooltip="Editar"
                      >
                        <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                      </button>
                      <button
                        *ngIf="detail.isEditMode"
                        color="primary"
                        mat-icon-button
                        (click)="
                            openOrderDetailUpdateConfirmation(
                              selectedOrder,
                              detail
                            )
                          "
                        matTooltip="Guardar"
                      >
                        <mat-icon svgIcon="heroicons_outline:check"></mat-icon>
                      </button>
                      <button
                        color="warn"
                        mat-icon-button
                        (click)="onCancelOrder(selectedOrder, detail)"
                        matTooltip="Eliminar"
                      >
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      </button>
                    </div>
                    <div *ngIf="detail.statusId == StatusEnum.INACTIVE">
                      <button
                        mat-icon-button
                        color="warn"
                        matTooltip="{{ detail.reasonForRejection }}"
                        [disabled]="
                            !(
                              detail.reasonForRejection &&
                              detail.reasonForRejection != ''
                            )
                          "
                      >
                        <mat-icon
                          svgIcon="heroicons_outline:chat-bubble-bottom-center-text"
                        ></mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <!-- Header Row -->
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsDetail"
                  class="bg-gray-100 dark:bg-gray-900"
                ></tr>
                <!-- Fila principal -->
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsDetail"
                  class="border-b"
                ></tr>
              </table>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #noData>
  <span> - </span>
</ng-template>

<ng-template #nestedTableTemplate>
  <mat-tab-group>
    <!-- Primer Tab con la primera tabla -->
    <mat-tab label="Métodos de Pago">
      <!-- <div class="overflow-hidden">
          <div class="flex border-b">
            <form class="flex w-full flex-col">
              <div class="flex flex-col py-6 px-13 sm:flex-row">
                <div class="flex flex-auto flex-wrap">
                  <div class="p-2 flex w-full flex-col"> -->
      <table
        mat-table
        [dataSource]="dataSourceInnerDetail"
        class="w-width min-w-500 overflow-y-visible mat-elevation-z"
        multiTemplateDataRows
        style="margin-top: 5px"
      >
        <ng-container matColumnDef="paymentMethod">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-left first-col table-tittle"
          >
            <p class="px-6">Tipo Pago</p>
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-left first-col table-text"
          >
            <p class="table-text-m px-6">{{ innerDetail.paymentType }}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="bank">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-left first-col table-tittle"
          >
            Banco
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-left first-col table-text"
          >
            <span class="table-text-code">{{ innerDetail?.bank }}</span><br />
            {{ innerDetail.accountNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="inner">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 first-col table-tittle w-min-detail-b"
          ></th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-center first-col table-text"
          >
            <button
              mat-icon-button
              (click)="toggleInner(innerDetail)"
              style="margin-left: 10px"
            >
              <mat-icon
                class="icon-size-5"
                [svgIcon]="
                            selectedInner?.id === innerDetail?.id
                              ? 'heroicons_solid:chevron-up'
                              : 'heroicons_solid:chevron-down'
                          "
              ></mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="operationNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-center first-col table-tittle"
          >
            N.Operacion
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-center first-col table-text"
          >
            {{ innerDetail.operationNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="paying">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-right first-col table-tittle"
          >
            Abono ({{this.currency}})
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-right first-col table-text"
          >
            {{ innerDetail.paying | moneda }}
          </td>
        </ng-container>

        <!-- Fila de detalles (siempre visible) -->
        <ng-container matColumnDef="expanded">
          <td
            mat-cell
            *matCellDef="let detail"
            [attr.colspan]="displayedColumnsInnerDetail.length"
          >
            <ng-container
              *ngIf="selectedInner?.id === detail.id"
              class="details-row"
            >
              <ng-container
                *ngTemplateOutlet="
           nestedTableTemplateInner;
            context: { $implicit: row }
          "
              ></ng-container>
            </ng-container></td
        ></ng-container>

        <!-- Cabeceras -->
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnsInnerDetail"
          class="sticky top-0 z-10  bg-white dark:bg-gray-900"
        ></tr>
        <!-- Filas principales -->
        <tr
          mat-row
          *matRowDef="let detail; columns: displayedColumnsInnerDetail;"
          class="border-b"
          [class.table-expanded-row]="
  selectedInner?.id === detail.id
"
        ></tr>

        <!-- Filas de detalles -->
        <tr
          mat-row
          *matRowDef="let row; columns: ['expanded']"
          class="table-detail-row"
        ></tr>
      </table>
      <!-- </div>
                </div>
              </div>
            </form>
          </div>
        </div> -->
    </mat-tab>

    <!-- Segundo Tab con la segunda tabla -->
    <mat-tab label="Documentos">
      <!-- <div class="overflow-hidden">
          <div class="flex border-b">
            <form class="flex w-full flex-col">
              <div class="flex flex-col py-6 px-13 sm:flex-row">
                <div class="flex flex-auto flex-wrap">
                  <div class="p-1 flex w-full flex-col">-->
      <table
        mat-table
        [dataSource]="dataSourceDocument"
        class="w-width min-w-500 overflow-y-visible mat-elevation-z"
        style="padding-top: 5px"
      >
        <ng-container matColumnDef="serials">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-center table-tittle"
          >
            #Pago
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-center table-text"
          >
            {{ innerDetail.serials }}
          </td>
        </ng-container>

        <ng-container matColumnDef="paymentType">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-center table-tittle"
          >
            Tipo
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-center table-text"
          >
            {{ innerDetail.documentType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="document">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-center table-tittle"
          >
            Nro. Documento
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-center table-text"
          >
            {{ innerDetail.document }}
          </td>
        </ng-container>

        <ng-container matColumnDef="afecto">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-center table-tittle"
          >
            Doc. Afecto
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-center table-text"
          >
            <ng-container *ngIf="innerDetail.paymentType.code === 'TP0006'">
              {{ innerDetail.creditNoteNumber }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="pendingPayment">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-right table-tittle"
          >
            Adeudado ({{this.currency}})
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-right table-text"
          >
            {{ innerDetail.pendingPayment | moneda }}
          </td>
        </ng-container>

        <ng-container matColumnDef="paying">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-right first-col table-tittle"
          >
            Abono ({{this.currency}})
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-right first-col table-text"
          >
            {{ innerDetail.paying | moneda }}
          </td>
        </ng-container>

        <ng-container matColumnDef="balance">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="px-6 text-right first-col table-tittle"
          >
            Saldo ({{this.currency}})
          </th>
          <td
            mat-cell
            *matCellDef="let innerDetail"
            class="px-6 text-right first-col table-text"
          >
            {{ innerDetail.balance | moneda}}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnsDocument"
          class="sticky top-0 z-10  bg-white dark:bg-gray-900"
        ></tr>
        <tr
          mat-row
          *matRowDef="let innerDetail; columns: displayedColumnsDocument"
        ></tr>
      </table>
      <!--   </div>
                </div>
              </div>
            </form>
          </div>
        </div> -->
    </mat-tab>
  </mat-tab-group>
</ng-template>

<ng-template #nestedTableTemplateInner>
  <!-- <div class="overflow-hidden">
          <div class="flex border-b">
            <form class="flex w-full flex-col">-->
  <!-- <div class="flex flex-col py-6 px-13 sm:flex-row">
                <div class="flex flex-auto flex-wrap">  -->
  <!-- <div class="pl-13 flex w-full flex-col "> -->
  <div class="p-1 pl-13 flex w-full flex-col">
    <table
      mat-table
      [dataSource]="dataSourceShip"
      class="w-width min-w-500 overflow-y-visible mat-elevation-z"
      multiTemplateDataRows
    >
      <ng-container matColumnDef="paymentType">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-6 text-left first-col table-tittle"
        >
          <p class="px-6">Tipo</p>
        </th>
        <td
          mat-cell
          *matCellDef="let innerDetail"
          class="px-6 text-left first-col table-text"
        >
          <p class="table-text-m px-6">{{ innerDetail?.documentType }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="document">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-6 text-center first-col table-tittle"
        >
          Nro. Documento
        </th>
        <td
          mat-cell
          *matCellDef="let innerDetail"
          class="px-6 text-center first-col table-text"
        >
          {{ innerDetail.document }}
        </td>
      </ng-container>

      <ng-container matColumnDef="paying">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="px-6 text-right first-col table-tittle"
        >
          Abono ({{this.currency}})
        </th>
        <td
          mat-cell
          *matCellDef="let innerDetail"
          class="px-6 text-right first-col table-text"
        >
          {{ innerDetail.paying | moneda }}
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumnsShip"
        class="sticky top-0 z-10  bg-white dark:bg-gray-900"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsShip;"></tr>
    </table>
  </div>
  <!-- </div>
              </div> -->
  <!--</form>
          </div>
        </div> -->
</ng-template>

<!-- Modal para confirmar actualización de un detalle -->
<!-- <ng-template #orderDetailUpdateConfirmationDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
      <div class="flex items-center">
        <mat-icon
          svgIcon="heroicons_outline:exclamation-triangle"
          class="text-yellow-500 ml-4 mt-6"
          style="font-size: 32px"
        ></mat-icon>
      </div>
      <div class="grid">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">
          Confirmar actualización
        </h2>
        <mat-dialog-content class="modal-content mt-0">
          <p>¿Está seguro que desea actualizar el detalle?</p>
        </mat-dialog-content>
      </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-between">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">
        Aceptar
      </button>
    </mat-dialog-actions>
  </ng-template> -->
